import { del, get, post, put } from '../client';

export const sitesApi = {
  list: (params) => get('/sites', { params }),
  getById: (id) => get(`/sites/${id}`),
  create: (body) => post('/sites', body),
  update: (id, body) => put(`/sites/${id}`, body),
  remove: (id) => del(`/sites/${id}`),
};
